import { Loading } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, memo, Suspense, useEffect } from 'react';
import { ContentsProps } from '../types';
import { BusinessDocumentSection } from './components/BusinessDocumentSection';
import { EDocMetadataSection } from './components/EDocMetadataSection';
import { useFileInfoDrawerData } from './hooks/useFileInfoDrawerData';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);

export const InnerContents: FC<ContentsProps> = ({
  businessDocumentId,
  onFileNameLoaded,
  onCloseDetailDrawer,
}) => {
  const {
    businessDoc,
    error,
    labels,
    eDocMetaProps,
    leftRightRatio,
    navigate,
    fileName,
  } = useFileInfoDrawerData(businessDocumentId, onCloseDetailDrawer);

  useEffect(() => {
    if (fileName && onFileNameLoaded) {
      onFileNameLoaded(fileName);
    }
  }, [fileName, onFileNameLoaded]);

  if (error || !businessDoc) {
    return null;
  }

  return (
    <div className={cx('container')}>
      <BusinessDocumentSection
        businessDoc={businessDoc}
        labels={labels}
        leftRightRatio={leftRightRatio}
        navigate={navigate}
      />

      {eDocMetaProps && <EDocMetadataSection eDocMetaProps={eDocMetaProps} />}
    </div>
  );
};

const FallBackLoading = () => {
  return (
    <div className={cx('loading-container')}>
      <Loading size='large' color='default' />
    </div>
  );
};

export const Contents: FC<ContentsProps> = memo((props) => {
  return (
    <Suspense fallback={<FallBackLoading />}>
      <InnerContents {...props} />
    </Suspense>
  );
});
Contents.displayName = 'Contents';
